<template>
  <div class='PedidosHeader'>
    <div class="c-status">
      <status-icon
      :options="{ width: '15px', height: '15px' }"
      text="Status"
      :active="true"
      :optionsLabel="{ marginTop: '50px' }"
      />
    </div>
    <div class="c-id">
      Pedido
    </div>
    <div style="width: 22.5%" class="mobile-none">
      Comprado
    </div>
    <div style="width: 27.5%" class="mobile-none">
      Endereço de entrega
    </div>
    <div class="c-valor">
      Vendas brutas
    </div>
    <div style="width: 10%" class="mobile-none">
      data
    </div>
    <div class="acoes">
      Ações
    </div>
  </div>
</template>

<script>
import StatusIcon from '../../Icons/StatusIcon'
export default {
  name: 'PedidosHeader',
  components: { StatusIcon }
}
</script>

<style scoped>
.PedidosHeader {
  display: flex;
  align-items: center;
  border-bottom: thin solid #CCCCCC;
  padding: 1%;
}

.c-status {
  width: 10%;
}

.c-id {
  width: 15%;
}

.c-valor {
  width: 10%;
}

.acoes {
  width: 6%;
  justify-content: center;
  align-items: center;
}

@media (max-width: 500px) {
  .mobile-none {
    display: none;
  }
  .c-status {
    width: 20%;
  }
  .c-id {
    width: 50%;
  }
  .c-valor {
    width: 20%;
  }
  .acoes {
    width: 9%;
    font-size: 12px;
  }
}
</style>
